module.exports = __webpack_public_path__ + "img/expenses-icon.e54f2121.svg";